export class APAdjustmentAttachmentRawDto {
    description: string;
    fileDataBase64: string;
    fileName: string;
    fileId: number;
    crudAction: string;
}
